export default {
  freeTimesLimitTitle: 'Бесплатная пробная версия закончилась сегодня.',
  fileSizeLimitTitle:
    'Размер файла в бесплатной версии не может превышать 20 МБ.',
  total: 'Все',
  enterCode: 'Ввести код',
  signUpToPurchaseBtn: 'Зарегистрироваться для покупки',
  goPurchseBtn: 'Перейти к покупке',
  saveTips: 'Сэкономить до {{num}}%',
  discount: 'Скидка',
  montly: 'Ежемесячный',
  yearly: 'Ежегодный',
  weekly: 'Еженедельно',
  week: 'неделю',
  priceWeek: '$9,99',
  priceMonth: '$7,49',
  priceYearly: '$3,75',
  billMonth: '$29.99 Оплата ежемесячно',
  billYear: '$179.99 Ежегодная оплата',
  AlreadySubscribe: 'Уже подписались?',
  vipTips1: 'Нет ограничений на размер файла',
  vipTips2: 'Нет ограничений на количество обрабатываемых файлов',
  vipTips3: 'Меняйте фон изображения без ограничений',
  vipTips4: 'Доступ ко всем бесплатным инструментам и премиум-функциям',
  purchaseTips:
    'Подписка будет автоматически продлена, и вы можете отменить ее в любое время.',
  tips: 'Примечание:',
  promoCodeInvalidTips: 'Ваш промокод недействителен',
};
